export default __webpack_public_path__ + "static/media/exit.b1f96a08.svg";